import { Component, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-notification-container',
  template: '<div #container></div>',
  styleUrls: [
    './notification.component.scss',
    './notification-container.component.scss',
  ],
})
export class NotificationContainerComponent {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  public viewContainerRef: ViewContainerRef;
}
